import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_pharmacy_details, save_pharmacy_details } from './api';
import type { PharmacyDetailsRequest } from './types';

const KEY = ['module-details', 'pharmacy'] as const;

export function use_save_pharmacy_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: PharmacyDetailsRequest) => save_pharmacy_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_pharmacy_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_pharmacy_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
